import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * PDF Editor Module Service Stores
 */
export const pdfEditorStores: ServiceStoreConfig[] = [
  {
    name: "pdf-documents",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "pdf-annotations",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "pdf-templates",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "pdf-storage",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  {
    name: "pdf-shares",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "pdf-document-shares",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  {
    name: "pdf-collaborators",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
];